const choicesGorvernanceCriteria = {
    considerationOfStakeholder: 'Prise en compte de l’avis des parties prenantes dans la direction de l’entreprise',
    auditOfFinancialStatements: 'Vérification des comptes par un tiers',
    diversityOnTheBoard: ' Diversité au sein du conseil d’administration',
    transparencyOfSalaries: ' Transparence des salaires',
    corruption: ' Lutte contre la corruption',
};

export default choicesGorvernanceCriteria;
